import React from "react";
import ReactHtmlParser from "react-html-parser";
import replaceImageCdn from "@herb/utils/replaceImageCdn";
import HempBanSectionHead from "@herb/components/HempBan/HempBanSectionHead";
import "./index.css";

/**
 * "The Loophole Just Got Closed" — the left column of the two-up story row.
 * Renders the intro copy plus a 2x2 grid of icon/tag/definition cards.
 */
const HempBanLoophole = ({ whatsHappening }) => {
  if (!whatsHappening) {
    return null;
  }

  const { badge1Text, heading1, text1, cards = [] } = whatsHappening;

  return (
    <div className="hb-loophole">
      <HempBanSectionHead badgeText={badge1Text} heading={heading1}>
        {text1 ? (
          <div className="hb-loophole-intro hb-rich">
            {ReactHtmlParser(text1)}
          </div>
        ) : null}
      </HempBanSectionHead>

      {cards && cards.length ? (
        <div className="hb-loophole-grid">
          {cards.map((card, index) => (
            <article
              className="hb-loophole-card"
              key={`${card.title || "card"}-${index}`}
            >
              <div className="hb-loophole-card-top">
                {card.icon?.sourceUrl ? (
                  <span className="hb-loophole-icon">
                    <img
                      src={replaceImageCdn(card.icon.sourceUrl)}
                      alt={card.icon.altText || ""}
                      loading="lazy"
                    />
                  </span>
                ) : null}
                {card.title ? (
                  <h3 className="hb-loophole-tag">{card.title}</h3>
                ) : null}
              </div>
              {card.text ? (
                <div className="hb-loophole-text hb-rich">
                  {ReactHtmlParser(card.text)}
                </div>
              ) : null}
            </article>
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default HempBanLoophole;
